const BYBIcon = ({ width = "16px", height = "16px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    width={width}
    height={height}
  >
    <path
      fill="#000"
      d="m29.51 22.25-2.08-3.74-1.75.97 2.08 3.74c.32.58.32 1.28-.02 1.85-.34.58-.94.92-1.61.92h-7.3l2.58-2.59L20 21.99l-5 5 5 5 1.41-1.41-2.58-2.59h7.3c1.38 0 2.63-.71 3.33-1.91.7-1.19.72-2.63.05-3.84v.01ZM5.87 26c-.67 0-1.27-.34-1.61-.92a1.83 1.83 0 0 1-.02-1.85l4.11-7.4 1.05 3.52 1.91-.57L9.3 12l-6.78 2.01.57 1.91 3.49-1.03-4.09 7.36a3.84 3.84 0 0 0 .05 3.84A3.84 3.84 0 0 0 5.87 28H12v-2H5.87ZM25.51 9.65l-1.05 3.52-5.11-9.2A3.8 3.8 0 0 0 16 2a3.8 3.8 0 0 0-3.35 1.97L9.57 9.51l1.75.97 3.08-5.54c.33-.59.93-.94 1.6-.94s1.27.35 1.6.94l5.09 9.17-3.49-1.03-.57 1.91L25.41 17l2.01-6.78-1.91-.57Z"
    />
  </svg>
);

export default BYBIcon;
